import {getRequest, patchRequest} from "@/libs/axios";


export const getSelfNotice = (params) => {
    return getRequest("/yethan/WebNotice/self/listPage", params)
}
export const getSelfNoticeCount = (params) => {
    return getRequest("/yethan/WebNotice/self/count", params)
}
